


//java side : server.port=8090
export const PORT = import.meta.env.VITE_PORT_MTEST_LOCAL_PORT   //)//'8090' 
export const PORT_GTW = import.meta.env.VITE_GTW_PORT_LOCAL_TCP_PORT   //)//'8092' 




export const DEFAULT_TIME_WINDOW_MINUTES =3     //10 //3//0 //3
export const ONE_HOUR_WINDOW_MINUTES=60 

export const emitLOG = true
export const LOG_SIZE = 48

export const DATA_0_ID = 'd908_798_poyfd_dj654'
export const DATA_1_ID = 'd908_798_klkgr_ht875'
export const DATA_2_ID = 'd908_798_jfrcs_mi305'

export const THING_PREFIX_NU_2='SC_';
export const THING_PREFIX1='SCALE_';
export const THING_PREFIX3='NSCALE_';
export const SENSOR_PREFIX1='N_';
export const SENSOR_PREFIX2='S_';
export const SENSOR_PREFIX3='P_';
export const SENSOR_PREFIX4='SSCALE_';
export const SENSOR_PREFIX5='NSCALE_';
export const SENSOR_PREFIX6='PSCALE_';
export const SENSOR_PREFIX7='HIVE_'; 
export const DEVICE_PREFIX0_NU='d0_';
export const DEVICE_PREFIX1_NU='d1_';

export const  DEVICE_PREFIX4_ = "N1_";
export const  DEVICE_PREFIX5_ = "S1_";
export const  DEVICE_PREFIX6_ = "P1_"; 

export const  SENSOR_PREFIX55 = "SSCALE_20AC0F";
export const  SENSOR_PREFIX56 = "SS_ABK";

export const  DEFAULT_VERSION_0 = "v1.1.0";
export const  VERSION_1 = "v1.1.1";


//r":"N_08D82240",
